// export const curPlayItem = state => state.curPlayItem;
// export const screenshot = state => state.screenshot;
// export const curPlayTime = state => state.curPlayTime;
// export const curPlayProgress = state => state.curPlayProgress;
// export const seektime = state => state.seektime;
export const userName = state => state.userName;
